/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconDecimal = createReactComponent("decimal", "IconDecimal", [
  [
    "path",
    {
      d: "M17 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z",
      key: "svg-0"
    }
  ],
  [
    "path",
    {
      d: "M10 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z",
      key: "svg-1"
    }
  ],
  ["path", { d: "M5 16h.01", key: "svg-2" }]
]);

export { IconDecimal as default };
//# sourceMappingURL=IconDecimal.js.map
